exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spo-btn label {\n  display: inline-block;\n  vertical-align: top;\n  margin: 0;\n  font-size: 18px;\n  padding-top: 8px;\n  padding-right: 15px;\n}\n\ntextarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/event/exhibitor-add-new/exhibitor-add-new.component.css
// module id = ../../../../../src/app/event/exhibitor-add-new/exhibitor-add-new.component.css
// module chunks = main